import React from "react";
import { StyledPill, PillStatus } from "./Pill.styled";
import { IconManager } from "../core/IconManager/IconManager";
import { BodyTyp } from "../Typography/Typography";
import { FontWeightEnum, IconSizeEnum } from "../../types/AppTypes";
import { theme } from "../../constants/StyledComponents";
import { ReactComponent as InfoIcon } from "../../icons/info.svg";

export type { PillStatus };

const pillTextColor: Record<PillStatus, string> = {
  active: theme.colors.purple,
  disabled: theme.colors.grey_4,
  error: theme.colors.red_1,
  default: theme.colors.black,
};

type PillProps = {
  status: PillStatus;
  label: React.ReactNode | string;
  showIcon?: boolean;
};

export const Pill = ({
  status,
  label,
  showIcon = true,
  ...rest
}: PillProps) => {
  const color = pillTextColor[status];

  return (
    <StyledPill $status={status} {...rest}>
      {showIcon && (
        <IconManager size={IconSizeEnum.SMALL} color={color}>
          <InfoIcon />
        </IconManager>
      )}
      <BodyTyp
        variant="2"
        fontWeight={FontWeightEnum.MEDIUM}
        color={color}
        noTranslate
      >
        {label}
      </BodyTyp>
    </StyledPill>
  );
};
